import Callout from '../../site/Callout';
import { bind, inject } from '../../../utils/decorators';
import { observer } from 'mobx-react';
import { action } from 'mobx';
import * as React from 'react';
import { Button, FormControl, Panel, Table } from 'react-bootstrap';
import { ISesSperrflaeche, SesSperrflaecheArt } from '../../../models/ApiTypesSes';
import FaIcon from '../../site/FaIcon';
import { SesAuswertungFlaechenRili2025Store } from '../../../stores/SesAuswertungFlaechenRili2025Store';

interface ISesAuswertungSperrflaecheProps {
  sperrFläche: ISesSperrflaeche;
  readonly: boolean;
  onSperrFlächeLöschen: (flaeche: ISesSperrflaeche) => void;
  onSperrFlächeÄndern: (flaeche: ISesSperrflaeche) => void;
}

@observer
class SesAuswertungSperrflaeche extends React.Component<ISesAuswertungSperrflaecheProps, {}> {

  @bind @action handleStartChanged(event: React.FormEvent<FormControl>) {
    let value = parseInt((event.target as HTMLInputElement).value, 10);
    this.props.sperrFläche.start = value;
    this.props.onSperrFlächeÄndern(this.props.sperrFläche);
  }

  @bind @action handleEndeChanged(event: React.FormEvent<FormControl>) {
    let value = parseInt((event.target as HTMLInputElement).value, 10);
    this.props.sperrFläche.ende = value;
    this.props.onSperrFlächeÄndern(this.props.sperrFläche);
  }

  @bind @action handleBeschreibungChanged(event: React.FormEvent<FormControl>) {
    this.props.sperrFläche.beschreibung = (event.target as HTMLInputElement).value;
  }

  render() {
    const { sperrFläche, readonly } = this.props;
    return (
        <tr>
          <td>
            <FormControl type="number" step="any" value={sperrFläche.start} onChange={this.handleStartChanged} readOnly={readonly}/>
          </td>
          <td>
            <FormControl type="number" step="any" className="input-fahrspurlaenge" value={sperrFläche.ende} onChange={this.handleEndeChanged} readOnly={readonly}/>
          </td>
          <td>
            <FormControl type="text" className="input-fahrspurlaenge" value={sperrFläche.beschreibung} onChange={this.handleBeschreibungChanged} readOnly={readonly}/>
          </td>
          <td>
            {!readonly &&
              <Button className="btn-flat" style={{padding: '0px', margin: '0px'}} title="Sperrfläche entfernen" onClick={() => this.props.onSperrFlächeLöschen(sperrFläche)}>
                <FaIcon icon="trash-o" />
              </Button>}
          </td>
        </tr>
    );
  }

}

interface ISesAuswertungSperrflaechenEingabeProps {
  art: SesSperrflaecheArt;
}

@observer
class SesAuswertungSperrflaechenEingabe extends React.Component<ISesAuswertungSperrflaechenEingabeProps, {}> {

  @inject(SesAuswertungFlaechenRili2025Store) store: SesAuswertungFlaechenRili2025Store;

  beurteilung: string = 'default';
  hinweise: string[] = [];

  @bind @action sperrFlächeHinzufügen(art: SesSperrflaecheArt) {
    this.store.messwerteFahrzeug.sperrflaechen.push({ start: 0, ende: 0, beschreibung: '', art: art});
  }

  @bind @action sperrFlächeLöschen(flaeche: ISesSperrflaeche) {
    const index = this.store.messwerteFahrzeug.sperrflaechen.indexOf(flaeche);
    this.store.messwerteFahrzeug.sperrflaechen.splice(index, 1);
  }

  @bind @action sperrFlächeÄndern() {
    this.store.onSperrFlaecheGeaendert();
  }

  @bind @action setBeurteilung(beurteilung: string) {
    this.beurteilung = beurteilung;
  }

  ermittleHinweise() {
    this.hinweise = [];

    // Die neue Richtlinie definiert unterschiedliche Kriterien für Sperrflächen, je nach Fahrzeugart
    let { messwerteFahrzeug } = this.store;
    let  sperrflaechen = messwerteFahrzeug.sperrflaechen.filter(flaeche => flaeche.art === this.props.art);

    if (this.props.art === 'kleinsteinbau') {
      // Lt. Richtlinie dürfen Kleinsteinbauten nie auf einem der Messpunkte liegen
      for (let messpunkt of messwerteFahrzeug.messpunkte) {
        var position = parseInt(messpunkt, 10);
        for (let sperrflaeche of sperrflaechen) {
          if (position >= sperrflaeche.start && position <= sperrflaeche.ende) {
            this.hinweise.push(`Kleinsteinbauten dürfen nicht auf einem Messpunkt liegen (${position}mm)`);
          }
        }
      }
      for (let sperrflaeche of sperrflaechen) {
        // Kleinsteinbauten dürfen max. 10cm lang sein
        if ((sperrflaeche.ende - sperrflaeche.start > 100)) {
          this.hinweise.push('Kleinsteinbauten dürfen max. 10cm lang sein');
          break;
        }
        // Kleinsteinbauten müssen eine positive Länge haben
        if ((sperrflaeche.ende <= sperrflaeche.start)) {
          this.hinweise.push('Länge der Kleinsteinbaut muss größer 0mm sein');
          break;
        }
      }
    } else {
      // Regeln für Sperrflächen unterscheiden sich je nach Fahrzeugart

      // Regeln für PKW
      if (messwerteFahrzeug.typ === 'PKW') {
          for (let sperrflaeche of sperrflaechen) {
            if (sperrflaeche.start <= 600) {
              this.hinweise.push('Sperrflächen müssen min. 60cm Abstand vom Beginn der Aufstellfläche haben');
              break;
            }
          }
          for (let sperrflaeche of sperrflaechen) {
            if ((sperrflaeche.ende - sperrflaeche.start > 1500)) {
              this.hinweise.push('Sperrfläche dürfen max. 150cm lang sein');
              break;
            }
          }
          if (sperrflaechen.length > 1) {
            this.hinweise.push('Es darf max. eine Sperrfläche vorhanden sein');
          }
      }

      // Regeln für LKW
      if (messwerteFahrzeug.typ === 'LKW') {
          for (let sperrflaeche of sperrflaechen) {
            if (sperrflaeche.start <= 900) {
              this.hinweise.push('Sperrflächen müssen min. 90cm Abstand vom Beginn der Aufstellfläche haben');
              break;
            }
          }
          if (sperrflaechen.length > 1) {
            for (let i = 1; i < sperrflaechen.length; i++) {
              if (Math.abs(sperrflaechen[i].start - sperrflaechen[i - 1].ende) < 1000) {
                this.hinweise.push('Sperrflächen müssen min. 100cm auseinanderliegen');
                break;
              }
            }
          }
          let gesamtLaenge = 0;
          for (let sperrflaeche of sperrflaechen) {
            gesamtLaenge += (sperrflaeche.ende - sperrflaeche.start);
          }
          if (gesamtLaenge > 2700) {
            this.hinweise.push('Die Gesamtlänge der Sperrflächen darf max. 270cm betragen');
          }
          if (sperrflaechen.filter(flaeche => flaeche.art === 'sperrflaeche').length > 2) {
            this.hinweise.push('Es dürfen max. zwei Sperrflächen vorhanden sein');
          }
      }

      // Regeln für KRAD
      if (messwerteFahrzeug.typ === 'KRAD') {
          for (let sperrflaeche of sperrflaechen) {
            if (sperrflaeche.art === 'sperrflaeche') {
              this.hinweise.push('Bei KRAD Aufstellflächen sind keine Sperrflächen erlaubt');
              break;
            }
          }
      }

      // Sperrflächen müssen eine positive Länge haben
      for (let sperrflaeche of sperrflaechen) {
        if ((sperrflaeche.ende <= sperrflaeche.start)) {
          this.hinweise.push('Länge der Sperrfläche muss größer 0mm sein');
          break;
        }
      }
    }

    // Panel soll optisch hervorgehoben werden, damit direkt erkennbar ist ob die Eingabe korrekt ist
    let beurteilung = 'default';
    if (sperrflaechen.length > 0) {
      beurteilung = this.hinweise.length > 0 ? 'danger' : 'success';
    }
    this.setBeurteilung(beurteilung);
  }

  render() {
    this.ermittleHinweise();
    var flaechen = this.store.messwerteFahrzeug.sperrflaechen.filter(el => el.art === this.props.art);
    var header = (this.props.art === 'sperrflaeche') ? 'Sperrflächen' : 'Kleinsteinbauten';
    header += ` (${flaechen.length})`;
    return (
        <Panel
            header={header}
            collapsible={true}
            defaultExpanded={false}
            bsStyle={this.beurteilung}
        >
          {flaechen.length > 0 &&
            <Table striped={false} bordered={true} condensed={true} hover={false} className="aufstellflaeche-punkte">
              <thead>
                <tr>
                  <th style={{textAlign: 'center', width: '96px'}}>Von <small>[mm]</small></th>
                  <th style={{textAlign: 'center', width: '96px'}}>Bis <small>[mm]</small></th>
                  <th style={{textAlign: 'center'}}>Beschreibung</th>
                  <th style={{textAlign: 'center', width: '32px'}}/>
                </tr>
              </thead>
              <tbody>
                {flaechen.map((flaeche, index) =>  (
                  <SesAuswertungSperrflaeche key={index} sperrFläche={flaeche} onSperrFlächeLöschen={this.sperrFlächeLöschen} onSperrFlächeÄndern={this.sperrFlächeÄndern} readonly={!this.store.editable} />
                ))}
              </tbody>
            </Table>}
            <div>
              {(this.hinweise.length > 0) &&
                <Callout bsStyle="danger">
                  {this.hinweise.map((hinweis, index) => (<p key={index}>{hinweis}</p>))}
                </Callout>
              }
            </div>
            <div className="text-right">
              {this.store.editable && <Button onClick={() => this.sperrFlächeHinzufügen(this.props.art)}>Hinzufügen</Button>}
            </div>
        </Panel>
      );
  }
}

@observer
export default class SesAuswertungSperrflaechen extends React.Component<{}, {}> {

  render() {
    return (
      <div>
        <SesAuswertungSperrflaechenEingabe art={'sperrflaeche'} />
        <SesAuswertungSperrflaechenEingabe art={'kleinsteinbau'} />
      </div>
      );
  }

}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/vorlagen/ses/SesAuswertungSperrflaechen.tsx